import axios from 'axios';

// Public blog + about-page endpoints (About Us + Blog CMS). Reuses the existing
// global axios instance (baseURL + Bearer token from main.js), same convention
// as subscriptionService.js.
export const blogService = {
  async posts({ page = 1, category = '', search = '', featuredOnly = false, perPage = 9 } = {}) {
    const params = { page, per_page: perPage };
    if (category) params.category = category;
    if (search) params.search = search;
    if (featuredOnly) params.featured_only = 1;
    const res = await axios.get('/web/blogs', { params });
    return res.data.data; // Laravel paginator: { data, current_page, last_page, total, ... }
  },
  async post(slug) {
    const res = await axios.get(`/web/blogs/${slug}`);
    return res.data; // { status, data, related }
  },
  async categories() {
    const res = await axios.get('/web/blog-categories');
    return res.data.data || [];
  },
  async aboutPage() {
    const res = await axios.get('/web/about-page');
    return res.data.data;
  },
};
